import { Amount } from '@mews-commander/types';
import { getCurrencyValue, SpacedDash } from '@mews-commander/ui';
import { LocalizedCurrencyValue, LocalizedText, Substitutes } from '@mews/framework';
import { areAmountsEqual } from '@mews-commander/utils';

interface AbsoluteProductOptionsTextProps {
    minPrice?: Amount;
    maxPrice?: Amount;
    substitutes: Substitutes;
    textKey: Mews.TextKey;
    isMultiTaxEnvironment: boolean;
}

const Price = ({
    minPrice,
    maxPrice,
    isMultiTaxEnvironment,
}: Pick<AbsoluteProductOptionsTextProps, 'minPrice' | 'maxPrice' | 'isMultiTaxEnvironment'>) => {
    if (!minPrice || !maxPrice) {
        return null;
    }

    if (areAmountsEqual(minPrice, maxPrice)) {
        return <LocalizedCurrencyValue value={getCurrencyValue({ amount: minPrice, net: isMultiTaxEnvironment })} />;
    }

    return (
        <>
            <LocalizedCurrencyValue value={getCurrencyValue({ amount: minPrice, net: isMultiTaxEnvironment })} />
            {SpacedDash}
            <LocalizedCurrencyValue value={getCurrencyValue({ amount: maxPrice, net: isMultiTaxEnvironment })} />
        </>
    );
};

const AbsoluteProductOptionsText = ({
    minPrice,
    maxPrice,
    substitutes,
    textKey,
    isMultiTaxEnvironment,
}: AbsoluteProductOptionsTextProps) => (
    <span>
        <Price minPrice={minPrice} maxPrice={maxPrice} isMultiTaxEnvironment={isMultiTaxEnvironment} />
        {textKey && (
            <span>
                {' '}
                <LocalizedText textKey={textKey} firstLowerCase substitutes={substitutes} />
            </span>
        )}
    </span>
);

export default AbsoluteProductOptionsText;
